import { render } from "./pesquisa.vue?vue&type=template&id=8282c1f2"
import script from "./pesquisa.vue?vue&type=script&lang=js"
export * from "./pesquisa.vue?vue&type=script&lang=js"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__